
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

import { Module } from "@/store/Module";
import { PanelLinksItem } from "@/types/generated/DifcamWebTypes";

const PanelModule = namespace(Module.Panel);
const UserModule = namespace(Module.User);

@Component({})
export default class PanelImageButton extends Vue {
  @PanelModule.State
  readonly imageButtonsLink!: PanelLinksItem[];

  @UserModule.State
  readonly foundInSyfadis!: boolean;

  get linksToDisplay() {
    return this.imageButtonsLink.filter(
      (link) => !link.displayOnlyToSyfadisUsers || this.foundInSyfadis
    );
  }
}
